import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/solarium/2.webp")